function BGShape(container) {
    this.container = container;
    this.mobileDetect = new MobileDetect(window.navigator.userAgent);

    this.shape = this.container.querySelector('.jsBgShape');
    this.shapeLines = this.shape.querySelectorAll('span');

    this.skewXMin = -35;
    this.skewXDiff = 12;

    this.skewYMin = -5;
    this.skewYDiff = 8;

    this.prevMobileX = this.skewXMin;
    this.prevMobileY = this.skewYMin;

    // Init
    this.setLineFades();

    // Set the initial transform
    TweenLite.set(this.shape, { skewX: this.skewXMin, skewY: this.skewYMin, rotationZ: 30 });
    TweenLite.to(this.shape, 3, { opacity: 0.2, ease: Power4.easeInOut });

    if (! this.mobileDetect.mobile()) {
        // Rotate the element when the mouse moves
        window.addEventListener('mousemove', e => {
            const percentX = (e.screenX / window.innerWidth * 100);
            const percentY = (e.screenY / window.innerHeight * 100);

            const skewX = this.skewXMin + -(this.skewXDiff / 100 * percentX);
            const skewY = this.skewYMin + -(this.skewYDiff / 100 * percentY);

            TweenLite.to(this.shape, 9, { skewX: skewX, skewY: skewY, opacity: 0.2, overwrite: 'all', ease: Power4.easeOut });
        });
    }
    else {
        this.animateMobile();
    }
};

BGShape.prototype.animateMobile = function() {
    const x = this.randomValue(this.skewXMin, this.skewXMin + this.skewXDiff);
    const y = this.randomValue(this.skewYMin, this.skewYMin + this.skewYDiff);

    const difference = Math.abs(Math.abs(this.prevMobileX - x) + Math.abs(this.prevMobileY - y));
    const maxDifference = this.skewXDiff + this.skewYDiff;
    const diffPercentage = difference / maxDifference * 100;

    const time = 10 / 100 * diffPercentage;

    this.prevMobileX = x;
    this.prevMobileY = y;

    TweenLite.to(this.shape, time, {
        skewX: x,
        skewY: y,
        ease: Power4.easeInOut,
        onComplete: this.animateMobile.bind(this),
        opacity: 0.2
    });
};

BGShape.prototype.setLineFades = function() {
    const lineCount = this.shapeLines.length;
    const percentage = 100 / lineCount;
    
    for (let i = 0; i < lineCount; i++) {
        TweenLite.set(this.shapeLines[i], { opacity: ((100 - (percentage * i)) / 100) });
    }
};

BGShape.prototype.randomValue = function(min, max) {
    if (max == null) { max = min; min = 0; }
    if (min > max) { var tmp = min; min = max; max = tmp; }
    return min + (max - min) * Math.random();
};